

interface Roles {
    admin : string,
    superAdmin:string,
    user:string,
    supremeAdmin:string,
}

const roles : Roles = {
    admin : "admin",
    superAdmin : "super-admin",
    user : "user",
    supremeAdmin : "supreme-admin"
}

export default roles